import { render, staticRenderFns } from "./AddEdtOrgDlg.vue?vue&type=template&id=01a79fd6"
import script from "./AddEdtOrgDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtOrgDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports